module.exports = __webpack_public_path__ + "img/select-arrow.00e2ada.svg";